<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="pt-md-3 pt-2 pr-md-3">
          <div class="d-flex justify-end">
            <v-btn text class="mr-2" color="#1e243e" @click="routerLink('/login')">
              <v-icon color="#1e243e">mdi-logout</v-icon> Kirish
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="mx-auto">
      <v-row>
        <v-col cols="12" class="text-center mt-md-13 mt-10">
          <p class="text-h4 mb-0">VIRTUAL QABUL</p>
        </v-col>
        <v-row class="d-flex justify-center">
          <v-col cols="12" md="4" class="mt-5 pa-3">
            <div class="d-flex align-center my-6">
              <div>
                <v-icon color="black" x-large>mdi-headset</v-icon>
              </div>
              <div>
                <p class="mb-0 ml-2 text-h6">Biz bilan bog'laning</p>
              </div>
            </div>
            <div class="d-flex align-center my-6">
              <div>
                <v-icon color="success" large>mdi-phone</v-icon>
              </div>
              <div class="ml-3">
                <p class="mb-0 font-weight-medium">Telefon</p>
                <p class="mb-0 text-body-2">+998 (71) 209 79 00</p>
              </div>
            </div>
            <div class="d-flex align-center my-6">
              <div>
                <v-icon color="success" large>mdi-email</v-icon>
              </div>
              <div class="ml-3">
                <p class="mb-0 font-weight-medium">Elektron manzil
                </p>
                <p class="mb-0 text-body-2">info@uzgeouniver.uz</p>
              </div>
            </div>
            <div class="d-flex align-center my-6">
              <div>
                <v-icon color="success" large>mdi-clock-time-four</v-icon>
              </div>
              <div class="ml-3">
                <p class="mb-0 font-weight-medium">Ish vaqti
                </p>
                <p class="mb-0 text-body-2">Dushanba - Juma 09:00 - 18:00</p>
              </div>
            </div>
            <div class="d-flex align-center my-6">
              <div>
                <v-icon color="success" large>mdi-navigation-variant</v-icon>
              </div>
              <div class="ml-3">
                <p class="mb-0 font-weight-medium">Manzil</p>
                <p class="mb-0 text-body-2">Toshkent sh., Mirzo Ulug'bek tumani, Olimlar ko'chasi, 64-uy
                </p>
              </div>
            </div>
            <div class="d-flex align-center my-6">
              <div>
                <v-icon color="success" large>mdi-robot</v-icon>
              </div>
              <div class="ml-3">
                <p class="mb-0 font-weight-medium">Telegram bot</p>
                <p class="mb-0 text-body-2"><a href="https://t.me/gfumurojaatbot" style="color: #1e243e">@gfumurojaatbot</a></p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="mt-5 pa-md-5 pa-3">
            <form @submit.prevent="sendForm()">
              <v-text-field v-model="personInformation.name" label="Ism" color="green darken-1" required></v-text-field>

              <v-text-field v-model="personInformation.last_name" label="Familiya" color="green darken-1" required></v-text-field>

              <v-select v-model="personInformation.catgory_of_person" :items="items" color="green darken-1"
                label="Shaxs toifasi" required></v-select>

              <v-select v-model="personInformation.send_who" :items="send" color="green darken-1" label="Murojaat kimga" required></v-select>

              <v-text-field v-model="personInformation.phone" label="Telefon" color="green darken-1"
                :rules="[$rules.required, $rules.phone]" v-inputmask="$masks.phone" required>
              </v-text-field>

              <v-text-field v-model="personInformation.email" :rules="emailRules" color="green darken-1" label="E-mail"
                required></v-text-field>

              <v-textarea v-model="personInformation.text" color="green darken-1" label="Matn" required></v-textarea>

              <v-btn color="success" type="submit">
                Yuborish
              </v-btn>
            </form>
          </v-col>
        </v-row>

        <v-col cols="12">
          <v-snackbar v-model="snackbar" min-width="250" timeout="2000" color="success" right top>
            <span class="white--text">Successful</span>
          </v-snackbar>
        </v-col>
        <v-col cols="12">
          <v-snackbar v-model="snackbarWarning" min-width="250" timeout="2000" color="warning" right top>
            <span class="white--text">You should fill this form</span>
          </v-snackbar>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "HomeView",
  data: () => ({
    snackbar: false,
    snackbarWarning: false,
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
    ],
    items: [
      'Jismoniy shaxs',
      'Yuridik shaxs',
    ],
    send: [
      'Rahbariyat',
      'Korrupsiyaga qarshi',
      'Foydali qazilma konlari geologiyasi fakulteti',
      'Neft va Gaz konlari geologiyasi fakulteti',
      'Boshqa'
    ],
    personInformation: {
      name: '',
      last_name: '',
      catgory_of_person: '',
      phone: '',
      send_who: '',
      email: null,
      text: null,
    }
  }),
  computed: {
    ...mapGetters("personal", ["person"])
  },

  mounted() {
    this.getPerson();
  },
  methods: {
    ...mapActions("personal", ["getPerson", "addPerson"]),
    sendForm() {
      if (this.personInformation) {
        setTimeout(() => {
          this.addPerson(this.personInformation)
          location.reload();
        }, 200);
        this.snackbar = !this.snackbar;
      }
      else {
        this.snackbarWarning = !this.snackbarWarning;
      }
    },
    routerLink(to) {
      this.$router.push(to);
    },
  }
};
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  color: #1e243e;
  text-decoration: none;
}
</style>